/* src/app/add-note/describe-secretion/describe-secretion.scss */
:root {
  --ion-background-color:
    linear-gradient(
      299deg,
      #371A09 2.43%,
      #885F26 100%);
  --ion-dark-background: #624120;
  --ion-color-primary-lightbrown: #785838;
  --ion-color-primary-lightgreen: #24615B;
  --ion-color-primary: #3880ff;
  --ion-color-primary-rgb:
    56,
    128,
    255;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-primary-shade: #3171e0;
  --ion-color-primary-tint: #4c8dff;
  --ion-color-primary-brown: #62412080;
  --ion-color-primary-brown-light: #9a6d3a;
  --ion-color-primary-darkgreen: #004147;
  --ion-color-primary-lightblue: #3FDECE;
  --ion-color-secondary: #3dc2ff;
  --ion-color-secondary-rgb:
    61,
    194,
    255;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-secondary-shade: #36abe0;
  --ion-color-secondary-tint: #50c8ff;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb:
    82,
    96,
    255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #2dd36f;
  --ion-color-success-rgb:
    45,
    211,
    111;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb:
    255,
    255,
    255;
  --ion-color-success-shade: #28ba62;
  --ion-color-success-tint: #42d77d;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb:
    255,
    196,
    9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb:
    0,
    0,
    0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb:
    235,
    68,
    90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb:
    255,
    255,
    255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-dark: #222428;
  --ion-color-dark-rgb:
    34,
    36,
    40;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb:
    255,
    255,
    255;
  --ion-color-dark-shade: #1e2023;
  --ion-color-dark-tint: #383a3e;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb:
    146,
    148,
    156;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb:
    255,
    255,
    255;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #f4f5f8;
  --ion-color-light-rgb:
    244,
    245,
    248;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb:
    0,
    0,
    0;
  --ion-color-light-shade: #d7d8da;
  --ion-color-light-tint: #f5f6f9;
  --gentle-rock-scale: 1.2;
}
@media (prefers-color-scheme: dark) {
  body {
    --ion-color-primary: #428cff;
    --ion-color-primary-rgb:
      66,
      140,
      255;
    --ion-color-primary-contrast: #ffffff;
    --ion-color-primary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-primary-shade: #3a7be0;
    --ion-color-primary-tint: #5598ff;
    --ion-color-secondary: #50c8ff;
    --ion-color-secondary-rgb:
      80,
      200,
      255;
    --ion-color-secondary-contrast: #ffffff;
    --ion-color-secondary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-secondary-shade: #46b0e0;
    --ion-color-secondary-tint: #62ceff;
    --ion-color-tertiary: #6a64ff;
    --ion-color-tertiary-rgb:
      106,
      100,
      255;
    --ion-color-tertiary-contrast: #ffffff;
    --ion-color-tertiary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-tertiary-shade: #5d58e0;
    --ion-color-tertiary-tint: #7974ff;
    --ion-color-success: #3FDECE;
    --ion-color-success-rgb:
      63,
      222,
      206;
    --ion-color-success-contrast: #000000;
    --ion-color-success-contrast-rgb:
      0,
      0,
      0;
    --ion-color-success-shade: #29c467;
    --ion-color-success-tint: #44e283;
    --ion-color-warning: #ffd534;
    --ion-color-warning-rgb:
      255,
      213,
      52;
    --ion-color-warning-contrast: #000000;
    --ion-color-warning-contrast-rgb:
      0,
      0,
      0;
    --ion-color-warning-shade: #e0bb2e;
    --ion-color-warning-tint: #ffd948;
    --ion-color-danger: #ff4961;
    --ion-color-danger-rgb:
      255,
      73,
      97;
    --ion-color-danger-contrast: #ffffff;
    --ion-color-danger-contrast-rgb:
      255,
      255,
      255;
    --ion-color-danger-shade: #e04055;
    --ion-color-danger-tint: #ff5b71;
    --ion-color-dark: #f4f5f8;
    --ion-color-dark-rgb:
      244,
      245,
      248;
    --ion-color-dark-contrast: #000000;
    --ion-color-dark-contrast-rgb:
      0,
      0,
      0;
    --ion-color-dark-shade: #d7d8da;
    --ion-color-dark-tint: #f5f6f9;
    --ion-color-medium: #989aa2;
    --ion-color-medium-rgb:
      152,
      154,
      162;
    --ion-color-medium-contrast: #000000;
    --ion-color-medium-contrast-rgb:
      0,
      0,
      0;
    --ion-color-medium-shade: #86888f;
    --ion-color-medium-tint: #a2a4ab;
    --ion-color-light: #222428;
    --ion-color-light-rgb:
      34,
      36,
      40;
    --ion-color-light-contrast: #ffffff;
    --ion-color-light-contrast-rgb:
      255,
      255,
      255;
    --ion-color-light-shade: #1e2023;
    --ion-color-light-tint: #383a3e;
  }
  .ios body {
    --ion-text-color: #ffffff;
    --ion-text-color-rgb:
      255,
      255,
      255;
    --ion-color-step-50: #0d0d0d;
    --ion-color-step-100: #1a1a1a;
    --ion-color-step-150: #262626;
    --ion-color-step-200: #333333;
    --ion-color-step-250: #404040;
    --ion-color-step-300: #4d4d4d;
    --ion-color-step-350: #595959;
    --ion-color-step-400: #666666;
    --ion-color-step-450: #737373;
    --ion-color-step-500: #808080;
    --ion-color-step-550: #8c8c8c;
    --ion-color-step-600: #999999;
    --ion-color-step-650: #a6a6a6;
    --ion-color-step-700: #b3b3b3;
    --ion-color-step-750: #bfbfbf;
    --ion-color-step-800: #cccccc;
    --ion-color-step-850: #d9d9d9;
    --ion-color-step-900: #e6e6e6;
    --ion-color-step-950: #f2f2f2;
    --ion-item-background: #000000;
    --ion-card-background: #1c1c1d;
  }
  .ios ion-modal {
    --ion-background-color: var(--ion-color-step-100);
    --ion-toolbar-background: var(--ion-color-step-150);
    --ion-toolbar-border-color: var(--ion-color-step-250);
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  ::ng-deep .buttons .button {
    font-size: 18px !important;
    height: 70px !important;
  }
}
@media screen and (max-width: 420px) and (max-height: 750px) and (orientation: portrait) {
  ::ng-deep .buttons .button {
    height: 50px !important;
    font-size: 13px !important;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  ::ng-deep .buttons .button {
    height: 50px !important;
    font-size: 13px !important;
  }
}
@media screen and (max-height: 425px) and (max-width: 740px) and (orientation: landscape) {
  ::ng-deep .buttons .button {
    height: 40px !important;
  }
}
.wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    linear-gradient(
      299deg,
      #371A09 2.43%,
      #885F26 100%);
}
.wrapper .content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
}
.wrapper .header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 27px 24px 0 0;
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .header {
    padding: 15px 15px 0 0;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .header {
    padding: 10px 10px 0 0;
  }
}
.wrapper .header .logo {
  width: 50px;
  height: 50px;
}
@media screen and (min-width: 768px) {
  .wrapper .header .logo {
    width: 80px;
    height: 80px;
  }
}
@media screen and (orientation: landscape) {
  .wrapper .header .logo {
    width: 50px;
    height: 50px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .header .logo {
    width: 40px;
    height: 40px;
  }
}
.wrapper .main {
  border-radius: 45px 45px 0 0;
  height: 80vh;
  background-color: var(--ion-color-primary-darkgreen);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 20px 40px;
}
@media screen and (max-width: 420px) and (orientation: portrait) {
  .wrapper .main {
    padding: 20px;
  }
}
@media screen and (max-width: 320px) and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main {
    padding: 10px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main {
    height: 75vh;
    padding: 10px 25px;
  }
}
.wrapper .main .mr-potty {
  position: absolute;
  top: -90px;
  left: 50%;
  transform: translateX(-50%);
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty {
    top: -80px;
  }
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .mr-potty {
    top: -60px;
  }
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .mr-potty img {
    width: 85px;
  }
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty img {
    width: 115px;
  }
}
.wrapper .main .main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex-grow: 1;
}
.wrapper .main .main-content .title {
  margin-top: 40px;
  color: var(--ion-color-primary-contrast);
  font-size: 24px;
  font-weight: 700;
  line-height: 35px;
}
@media screen and (min-width: 425px) and (min-height: 500px) {
  .wrapper .main .main-content .title {
    font-size: 28px;
  }
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .title {
    margin-top: 15px;
    margin-bottom: 0;
    font-size: 20px;
    line-height: 30px;
  }
}
@media screen and (max-height: 640px) and (orientation: portrait) {
  .wrapper .main .main-content .title {
    margin-top: 25px;
    margin-bottom: 0;
  }
}
@media screen and (max-width: 340px) and (orientation: portrait) {
  .wrapper .main .main-content .title {
    font-size: 20px;
  }
}
.wrapper .main .main-content app-progress-bar {
  margin: 15px 0 0 0;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content app-progress-bar {
    margin-top: 5px;
  }
}
@media screen and (max-height: 640px) and (orientation: portrait) {
  .wrapper .main .main-content app-progress-bar {
    margin-top: 10px;
  }
}
.wrapper .main .main-content .pee-poo-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 100%;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper {
    flex-direction: row;
    align-items: center;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .pee-poo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3vh;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .pee-poo {
    flex-direction: row;
    align-items: center;
    width: 100%;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .pee-poo.horizontal {
  margin-top: 3vh;
  flex-direction: row;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .pee-poo.horizontal {
    margin-top: 0;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .pee-poo.horizontal .pee-poo__button {
  width: 15vh;
  height: 15vh;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .pee-poo.horizontal .pee-poo__button {
    width: 25vh;
    height: 25vh;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .pee-poo.horizontal .pee-poo__button img {
  width: 8vh;
  height: 9vh;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .pee-poo.horizontal .pee-poo__button img {
    width: 12vh;
    height: 15vh;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .pee-poo__button {
  width: 20vh;
  height: 20vh;
  border-radius: 50%;
  background-color: #00292D;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .pee-poo__button {
    width: 25vh;
    height: 25vh;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .pee-poo__button img {
  width: 10vh;
  height: 12vh;
}
.wrapper .main .main-content .pee-poo-wrapper .pee-poo__button.selected {
  background-color: var(--ion-color-primary-contrast);
}
.wrapper .main .main-content .pee-poo-wrapper .cards {
  width: calc(100% + 80px);
  overflow-x: auto;
  display: flex;
  align-items: center;
  margin: 0 -40px;
  padding: 0 40px;
  gap: 3vw;
  flex-grow: 1;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
}
.wrapper .main .main-content .pee-poo-wrapper .cards::-webkit-scrollbar {
  display: none;
}
.wrapper .main .main-content .pee-poo-wrapper .cards .card {
  flex: 0 0 auto;
  width: 150px;
  height: 175px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--ion-color-primary-contrast);
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card {
    height: 30vh;
  }
}
@media screen and (min-width: 425px) and (min-height: 500px) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card {
    width: 35vw;
    height: 25vh;
  }
}
@media screen and (max-width: 360px) and (max-height: 650px) and (orientation: portrait) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card {
    width: 130px;
    height: 155px;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .cards .card.selected {
  background: var(--ion-color-primary-contrast);
  color: var(--ion-color-primary-darkgreen);
}
.wrapper .main .main-content .pee-poo-wrapper .cards .card__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img {
  width: 120px;
  height: 70px;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img {
    width: 25vh;
    height: 15vh;
  }
}
@media screen and (max-width: 360px) and (max-height: 650px) and (orientation: portrait) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img {
    width: 100px;
    height: 60px;
  }
}
@media screen and (min-width: 425px) and (min-height: 500px) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img {
    width: 31vw;
    height: 9vh;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img.pee {
  width: 64px;
  height: 85px;
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img.pee {
    width: 12vh;
    height: 17vh;
  }
}
@media screen and (max-width: 360px) and (max-height: 650px) and (orientation: portrait) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img.pee {
    width: 54px;
    height: 75px;
  }
}
@media screen and (min-width: 425px) and (min-height: 500px) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .img.pee {
    width: 17vw;
    height: 11vh;
  }
}
.wrapper .main .main-content .pee-poo-wrapper .cards .card__content .text {
  width: 100px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin: 0;
}
@media screen and (min-width: 425px) and (min-height: 500px) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .text {
    font-size: 16px;
    width: 150px;
  }
}
@media screen and (max-height: 424px) and (orientation: landscape) {
  .wrapper .main .main-content .pee-poo-wrapper .cards .card__content .text {
    font-size: 11px;
    line-height: 13px;
  }
}
/*# sourceMappingURL=describe-secretion.css.map */
